var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSierraLeone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 21.5752C31.648 19.8418 32 17.9671 32 16.01C32 14.0528 31.648 12.1781 31.0048 10.4448L16 9.05345L0.995188 10.4448C0.352 12.1781 0 14.0528 0 16.01C0 17.9671 0.352 19.8418 0.995188 21.5752L16 22.9665L31.0048 21.5752Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 32.0098C22.8796 32.0098 28.7444 27.6678 31.005 21.575H0.995361C3.25611 27.6678 9.12074 32.0098 16.0002 32.0098Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 0.00976562C9.12074 0.00976562 3.25611 4.35177 0.995361 10.4446H31.005C28.7444 4.35177 22.8796 0.00976562 16.0002 0.00976562Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.00976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSierraLeone);
export default __webpack_public_path__ + "static/media/sierra-leone.819a95ee.svg";
export { ForwardRef as ReactComponent };